import { parseData, post } from './common';
const sendEmail = (email, message, status) => {
    let toAddress;
    let subject;
    if (status === 'Fraudulent') {
        toAddress = 'support@cards.emburse.com';
        subject = 'Potential Fraudulent Account: Message from Company';
    }
    else {
        toAddress = 'billing@certify.com';
        subject = 'Account Locked Due to Non-Payment';
    }
    return post('/InternalAPI/AccountStatusAPI.asmx/SendEmail', {
        Email: email,
        Message: message,
        ToAddress: toAddress,
        Subject: subject
    }).then(parseData);
};
export { sendEmail };
